import React from 'react'

const useLocalStorage = <T>(storageKey: string, defaultState: T) => {
  const [value, setValue] = React.useState<T>((): T => {
    if (localStorage.getItem(storageKey) !== 'undefined') {
      try {
        if (JSON.parse(localStorage.getItem(storageKey) as string) === null) {
          return defaultState
        }
        return JSON.parse(localStorage.getItem(storageKey) as string)
      } catch (error) {
        return defaultState
      }
    }
    return defaultState
  })

  React.useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(value))
  }, [value, storageKey])

  const handleSetValue = (value: T) => {
    setValue(value)
    localStorage.setItem(storageKey, JSON.stringify(value))
  }

  return [value, handleSetValue] as const
}

export default useLocalStorage
